// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file src/protos/learning_management/lms.liveQuiz.student.apis.proto (package geneo.lms.liveQuiz.student.apis, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, protoInt64 } from "@bufbuild/protobuf";
import { ContentAttempt, LiveQuizParticipantAnswerReveal, LiveQuizQuestionSession, LiveQuizSession, MetricsModel, SessionStatusEnum } from "@protos/learning_management/lms.db_pb";
import { Question } from "@protos/content_management/content.db_pb";

/**
 * @generated from message geneo.lms.liveQuiz.student.apis.GetActiveLiveQuizForStudentRequest
 */
export class GetActiveLiveQuizForStudentRequest extends Message<GetActiveLiveQuizForStudentRequest> {
  /**
   * @generated from field: int64 student_id = 1;
   */
  studentId = protoInt64.zero;

  constructor(data?: PartialMessage<GetActiveLiveQuizForStudentRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.liveQuiz.student.apis.GetActiveLiveQuizForStudentRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "student_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetActiveLiveQuizForStudentRequest {
    return new GetActiveLiveQuizForStudentRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetActiveLiveQuizForStudentRequest {
    return new GetActiveLiveQuizForStudentRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetActiveLiveQuizForStudentRequest {
    return new GetActiveLiveQuizForStudentRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetActiveLiveQuizForStudentRequest | PlainMessage<GetActiveLiveQuizForStudentRequest> | undefined, b: GetActiveLiveQuizForStudentRequest | PlainMessage<GetActiveLiveQuizForStudentRequest> | undefined): boolean {
    return proto3.util.equals(GetActiveLiveQuizForStudentRequest, a, b);
  }
}

/**
 * @generated from message geneo.lms.liveQuiz.student.apis.GetActiveLiveQuizForStudentResponse
 */
export class GetActiveLiveQuizForStudentResponse extends Message<GetActiveLiveQuizForStudentResponse> {
  /**
   * @generated from field: int32 status = 1;
   */
  status = 0;

  /**
   * @generated from field: string code = 2;
   */
  code = "";

  /**
   * @generated from field: string message = 3;
   */
  message = "";

  /**
   * deprecated: most-recent of live_quiz_sessions below, kept for older clients
   *
   * @generated from field: optional geneo.lms.db.LiveQuizSession live_quiz_session = 4;
   */
  liveQuizSession?: LiveQuizSession;

  /**
   * one per section the student is enrolled in that currently has a live quiz running — usually zero or one, but a student can be in more than one section (different subjects)
   *
   * @generated from field: repeated geneo.lms.db.LiveQuizSession live_quiz_sessions = 5;
   */
  liveQuizSessions: LiveQuizSession[] = [];

  constructor(data?: PartialMessage<GetActiveLiveQuizForStudentResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.liveQuiz.student.apis.GetActiveLiveQuizForStudentResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "live_quiz_session", kind: "message", T: LiveQuizSession, opt: true },
    { no: 5, name: "live_quiz_sessions", kind: "message", T: LiveQuizSession, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetActiveLiveQuizForStudentResponse {
    return new GetActiveLiveQuizForStudentResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetActiveLiveQuizForStudentResponse {
    return new GetActiveLiveQuizForStudentResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetActiveLiveQuizForStudentResponse {
    return new GetActiveLiveQuizForStudentResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetActiveLiveQuizForStudentResponse | PlainMessage<GetActiveLiveQuizForStudentResponse> | undefined, b: GetActiveLiveQuizForStudentResponse | PlainMessage<GetActiveLiveQuizForStudentResponse> | undefined): boolean {
    return proto3.util.equals(GetActiveLiveQuizForStudentResponse, a, b);
  }
}

/**
 * @generated from message geneo.lms.liveQuiz.student.apis.JoinLiveQuizSessionRequest
 */
export class JoinLiveQuizSessionRequest extends Message<JoinLiveQuizSessionRequest> {
  /**
   * @generated from field: int64 student_id = 1;
   */
  studentId = protoInt64.zero;

  /**
   * @generated from field: int64 live_quiz_session_id = 2;
   */
  liveQuizSessionId = protoInt64.zero;

  constructor(data?: PartialMessage<JoinLiveQuizSessionRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.liveQuiz.student.apis.JoinLiveQuizSessionRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "student_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "live_quiz_session_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): JoinLiveQuizSessionRequest {
    return new JoinLiveQuizSessionRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): JoinLiveQuizSessionRequest {
    return new JoinLiveQuizSessionRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): JoinLiveQuizSessionRequest {
    return new JoinLiveQuizSessionRequest().fromJsonString(jsonString, options);
  }

  static equals(a: JoinLiveQuizSessionRequest | PlainMessage<JoinLiveQuizSessionRequest> | undefined, b: JoinLiveQuizSessionRequest | PlainMessage<JoinLiveQuizSessionRequest> | undefined): boolean {
    return proto3.util.equals(JoinLiveQuizSessionRequest, a, b);
  }
}

/**
 * @generated from message geneo.lms.liveQuiz.student.apis.JoinLiveQuizSessionResponse
 */
export class JoinLiveQuizSessionResponse extends Message<JoinLiveQuizSessionResponse> {
  /**
   * @generated from field: int32 status = 1;
   */
  status = 0;

  /**
   * @generated from field: string code = 2;
   */
  code = "";

  /**
   * @generated from field: string message = 3;
   */
  message = "";

  /**
   * @generated from field: optional int64 student_homework_session_id = 4;
   */
  studentHomeworkSessionId?: bigint;

  /**
   * for signInWithCustomToken on the student client
   *
   * @generated from field: optional string firestore_custom_token = 5;
   */
  firestoreCustomToken?: string;

  /**
   * lets a late joiner render the right screen immediately
   *
   * @generated from field: optional geneo.lms.db.LiveQuizQuestionSession current_question = 6;
   */
  currentQuestion?: LiveQuizQuestionSession;

  /**
   * full content for every question in the session, correct answers/solutions stripped — fetched once here so the client never re-fetches per question
   *
   * @generated from field: repeated geneo.content.db.Question questions = 7;
   */
  questions: Question[] = [];

  constructor(data?: PartialMessage<JoinLiveQuizSessionResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.liveQuiz.student.apis.JoinLiveQuizSessionResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "student_homework_session_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 5, name: "firestore_custom_token", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 6, name: "current_question", kind: "message", T: LiveQuizQuestionSession, opt: true },
    { no: 7, name: "questions", kind: "message", T: Question, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): JoinLiveQuizSessionResponse {
    return new JoinLiveQuizSessionResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): JoinLiveQuizSessionResponse {
    return new JoinLiveQuizSessionResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): JoinLiveQuizSessionResponse {
    return new JoinLiveQuizSessionResponse().fromJsonString(jsonString, options);
  }

  static equals(a: JoinLiveQuizSessionResponse | PlainMessage<JoinLiveQuizSessionResponse> | undefined, b: JoinLiveQuizSessionResponse | PlainMessage<JoinLiveQuizSessionResponse> | undefined): boolean {
    return proto3.util.equals(JoinLiveQuizSessionResponse, a, b);
  }
}

/**
 * @generated from message geneo.lms.liveQuiz.student.apis.SubmitLiveQuizResponseRequest
 */
export class SubmitLiveQuizResponseRequest extends Message<SubmitLiveQuizResponseRequest> {
  /**
   * @generated from field: int64 student_id = 1;
   */
  studentId = protoInt64.zero;

  /**
   * @generated from field: int64 live_quiz_session_id = 2;
   */
  liveQuizSessionId = protoInt64.zero;

  /**
   * @generated from field: int64 live_quiz_question_session_id = 3;
   */
  liveQuizQuestionSessionId = protoInt64.zero;

  /**
   * @generated from field: string question_id = 4;
   */
  questionId = "";

  /**
   * @generated from field: geneo.lms.db.ContentAttempt response = 5;
   */
  response?: ContentAttempt;

  /**
   * @generated from field: optional int32 section_no = 6;
   */
  sectionNo?: number;

  constructor(data?: PartialMessage<SubmitLiveQuizResponseRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.liveQuiz.student.apis.SubmitLiveQuizResponseRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "student_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "live_quiz_session_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "live_quiz_question_session_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "question_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "response", kind: "message", T: ContentAttempt },
    { no: 6, name: "section_no", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SubmitLiveQuizResponseRequest {
    return new SubmitLiveQuizResponseRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SubmitLiveQuizResponseRequest {
    return new SubmitLiveQuizResponseRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SubmitLiveQuizResponseRequest {
    return new SubmitLiveQuizResponseRequest().fromJsonString(jsonString, options);
  }

  static equals(a: SubmitLiveQuizResponseRequest | PlainMessage<SubmitLiveQuizResponseRequest> | undefined, b: SubmitLiveQuizResponseRequest | PlainMessage<SubmitLiveQuizResponseRequest> | undefined): boolean {
    return proto3.util.equals(SubmitLiveQuizResponseRequest, a, b);
  }
}

/**
 * @generated from message geneo.lms.liveQuiz.student.apis.SubmitLiveQuizResponseResponse
 */
export class SubmitLiveQuizResponseResponse extends Message<SubmitLiveQuizResponseResponse> {
  /**
   * @generated from field: int32 status = 1;
   */
  status = 0;

  /**
   * @generated from field: string code = 2;
   */
  code = "";

  /**
   * @generated from field: string message = 3;
   */
  message = "";

  /**
   * acknowledgement only — never isCorrect/score, see teacher-controlled reveal
   *
   * @generated from field: bool is_attempted = 4;
   */
  isAttempted = false;

  constructor(data?: PartialMessage<SubmitLiveQuizResponseResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.liveQuiz.student.apis.SubmitLiveQuizResponseResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "is_attempted", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SubmitLiveQuizResponseResponse {
    return new SubmitLiveQuizResponseResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SubmitLiveQuizResponseResponse {
    return new SubmitLiveQuizResponseResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SubmitLiveQuizResponseResponse {
    return new SubmitLiveQuizResponseResponse().fromJsonString(jsonString, options);
  }

  static equals(a: SubmitLiveQuizResponseResponse | PlainMessage<SubmitLiveQuizResponseResponse> | undefined, b: SubmitLiveQuizResponseResponse | PlainMessage<SubmitLiveQuizResponseResponse> | undefined): boolean {
    return proto3.util.equals(SubmitLiveQuizResponseResponse, a, b);
  }
}

/**
 * @generated from message geneo.lms.liveQuiz.student.apis.GetLiveQuizStudentStateRequest
 */
export class GetLiveQuizStudentStateRequest extends Message<GetLiveQuizStudentStateRequest> {
  /**
   * @generated from field: int64 student_id = 1;
   */
  studentId = protoInt64.zero;

  /**
   * @generated from field: int64 live_quiz_session_id = 2;
   */
  liveQuizSessionId = protoInt64.zero;

  constructor(data?: PartialMessage<GetLiveQuizStudentStateRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.liveQuiz.student.apis.GetLiveQuizStudentStateRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "student_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "live_quiz_session_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetLiveQuizStudentStateRequest {
    return new GetLiveQuizStudentStateRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetLiveQuizStudentStateRequest {
    return new GetLiveQuizStudentStateRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetLiveQuizStudentStateRequest {
    return new GetLiveQuizStudentStateRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetLiveQuizStudentStateRequest | PlainMessage<GetLiveQuizStudentStateRequest> | undefined, b: GetLiveQuizStudentStateRequest | PlainMessage<GetLiveQuizStudentStateRequest> | undefined): boolean {
    return proto3.util.equals(GetLiveQuizStudentStateRequest, a, b);
  }
}

/**
 * @generated from message geneo.lms.liveQuiz.student.apis.GetLiveQuizStudentStateResponse
 */
export class GetLiveQuizStudentStateResponse extends Message<GetLiveQuizStudentStateResponse> {
  /**
   * @generated from field: int32 status = 1;
   */
  status = 0;

  /**
   * @generated from field: string code = 2;
   */
  code = "";

  /**
   * @generated from field: string message = 3;
   */
  message = "";

  /**
   * @generated from field: geneo.lms.db.SessionStatusEnum session_status = 4;
   */
  sessionStatus = SessionStatusEnum.SESSION_STATUS_UNDEFINED;

  /**
   * @generated from field: optional geneo.lms.db.LiveQuizQuestionSession current_question = 5;
   */
  currentQuestion?: LiveQuizQuestionSession;

  /**
   * @generated from field: bool has_answered_current = 6;
   */
  hasAnsweredCurrent = false;

  /**
   * present only once the teacher has revealed the current/last question
   *
   * @generated from field: optional geneo.lms.db.LiveQuizParticipantAnswerReveal revealed_result = 7;
   */
  revealedResult?: LiveQuizParticipantAnswerReveal;

  /**
   * full content for every question in the session, correct answers/solutions stripped — kept in every resync response so a page refresh never loses question content
   *
   * @generated from field: repeated geneo.content.db.Question questions = 8;
   */
  questions: Question[] = [];

  /**
   * the student's own final score for this session — present only once session_status is SESSION_STATUS_COMPLETED
   *
   * @generated from field: optional geneo.lms.db.MetricsModel final_metrics = 9;
   */
  finalMetrics?: MetricsModel;

  constructor(data?: PartialMessage<GetLiveQuizStudentStateResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.liveQuiz.student.apis.GetLiveQuizStudentStateResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "session_status", kind: "enum", T: proto3.getEnumType(SessionStatusEnum) },
    { no: 5, name: "current_question", kind: "message", T: LiveQuizQuestionSession, opt: true },
    { no: 6, name: "has_answered_current", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 7, name: "revealed_result", kind: "message", T: LiveQuizParticipantAnswerReveal, opt: true },
    { no: 8, name: "questions", kind: "message", T: Question, repeated: true },
    { no: 9, name: "final_metrics", kind: "message", T: MetricsModel, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetLiveQuizStudentStateResponse {
    return new GetLiveQuizStudentStateResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetLiveQuizStudentStateResponse {
    return new GetLiveQuizStudentStateResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetLiveQuizStudentStateResponse {
    return new GetLiveQuizStudentStateResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetLiveQuizStudentStateResponse | PlainMessage<GetLiveQuizStudentStateResponse> | undefined, b: GetLiveQuizStudentStateResponse | PlainMessage<GetLiveQuizStudentStateResponse> | undefined): boolean {
    return proto3.util.equals(GetLiveQuizStudentStateResponse, a, b);
  }
}

